var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contentWrap joinsect"},[_c('div',{staticClass:"peopleNum"},[_c('p',[_vm._v("已有 "),_c('span',[_vm._v(_vm._s(_vm.peopleNum))]),_vm._v("位兄弟再次集结 ")]),_c('span',[_vm._v("5月20日新服【渡劫封仙】爆燃开启")])])])}
var staticRenderFns = []

export { render, staticRenderFns }